export enum enumTicketType {
  TICKET = 1,
  STAGING = 2,
  VERBALE = 3,
  RAEE = 4,
}
